import React from "react";
import { useState } from "react";

const Button = ({ children, onclick, type = "submit", setButtonEnabled }) => {
  //console.log('Button received buttonEnabled:', setButtonEnabled);

  const [isDisabled, setIsDisabled] = useState(!setButtonEnabled);
  
  return (
    //<button className="form-button" onClick={onClick} type={type} disabled={!setButtonEnabled}>{children}</button>
    <button className={"form-button " + (isDisabled ? "disabled" : "")} onClick={onclick} type={type} disabled={!setButtonEnabled}>{children}</button>

  )
};

export default Button;